import UTCDateTime from '@/lib/utc-datetime'
import moment from 'moment'
import Operation from '@/lib/operation'
import * as Constants from '@/lib/constants'
import UserInfo from '@/lib/user-info'

export default {
  data() {
    return {
      // AccountQuery
      selectedAccountUuids: [this.$store.getters.loginUsername],
      accountsAllSelected: false,
      filterStringAccountUuids: '',

      // FieldQuery
      selectedFieldGeoInfoKeys: [],
      fieldsAllSelected: false,
      fieldsFilterFlg: false,
      filterStringFieldGeoInfoKeys: '',

      // CropQuery
      // selectedCropIds: [],
      // cropsAllSelected: false,
      // cropsFilterFlg: false,
      // filterStringCropIds: '',

      // OperationTypeQuery
      selectedOperationTypes: [],
      operationTypesAllSelected: false,
      operationTypesFilterFlg: false,
      filterStringOperationTypes: '',

      areaZeroHiddenFlg: false,
      distanceUnderTenHiddenFlg: false,
      outOfFieldHiddenFlg: false,

      // DateFilter
      filterDateFrom: this.toMonthString(new Date('2014/01/02')), //TODO 履歴の一番過去の日付を取得するようにする
      filterDateTo: this.toMonthString(new Date()),
      selectPickerType: Constants.DATE_PICKER_TYPE_MONTH,
    }
  },

  methods: {
    buildTaskFilter(fromMoment, toMoment) {
      const from = fromMoment || this.utcStringOfDateFilterFrom()
      const to = toMoment || this.utcStringOfDateFilterTo()
      const dateTimeRange = {
        type: 'Start',
        from: from,
        to: to,
      }
      let queries = []

      // AccountQuery
      let query = this.getAccountQuery()
      if (query) {
        queries.push(query)
      }
      // FieldQuery
      query = this.getFieldQuery()
      if (query) {
        queries.push(query)
      }

      // CropQuery
      // query = this.getCropQuery()
      // if (query) {
      //   queries.push(query)
      // }

      // OperationTypeQuery
      query = this.getOperationTypeQuery()
      if (query) {
        queries.push(query)
      }

      // AreaZeroHiddenQuery
      if (this.areaZeroHiddenFlg) {
        queries.push(this.getAreaNotEqualsZeroQuery())
      }

      // DistanceUnderTenHiddenQuery
      if (this.distanceUnderTenHiddenFlg) {
        queries.push(this.getDistanceMoreThanEquals10Query())
      }

      return { dateTimeRange, queries }
    },
    toDateString(date) {
      return date.toISOString().substr(0, 10)
    },
    toMonthString(date) {
      return date.toISOString().substr(0, 7)
    },
    getEarlyMonth(date) {
      let dateWk = new Date(date)
      dateWk.setDate(1)
      return dateWk
    },
    incrementDate(date, dateCount) {
      let dateWk = new Date(date)
      dateWk.setDate(dateWk.getDate() + dateCount)
      return dateWk
    },
    getEndOfMonth(date) {
      let dateWk = new Date(date)
      dateWk.setDate(1)
      dateWk.setMonth(date.getMonth() + 1)
      dateWk.setDate(0)
      return dateWk
    },
    utcStringOfDateFilterFrom() {
      let dateWk = new Date(this.filterDateFrom)
      if (this.selectPickerType === Constants.DATE_PICKER_TYPE_MONTH) {
        dateWk = this.getEarlyMonth(dateWk)
      }
      return UTCDateTime.utcStringFromMomentObject(moment(dateWk))
    },
    utcStringOfDateFilterTo() {
      let dateWk = new Date(this.filterDateTo)
      if (this.selectPickerType === Constants.DATE_PICKER_TYPE_MONTH) {
        dateWk = this.getEndOfMonth(dateWk)
      }
      dateWk = this.incrementDate(dateWk, 1)
      return UTCDateTime.utcStringFromMomentObject(moment(dateWk))
    },
    //--------------------
    // AccountQuery
    //--------------------
    getAccountQuery() {
      let accountQuery = { type: 'Account', uuids: [] }
      // 何も選択されていない-->全員対象
      if (this.selectedAccountUuids.length === 0) {
        accountQuery.uuids.push(this.myUsername)
        for (let i = 0; i < this.subscribingUserInfos.length; i++) {
          accountQuery.uuids.push(this.subscribingUserInfos[i].uuid)
        }
      } else {
        for (let i = 0; i < this.selectedAccountUuids.length; i++) {
          accountQuery.uuids.push(this.selectedAccountUuids[i])
        }
      }
      return accountQuery
    },
    toggleSelectedAccountUuids(val) {
      this.accountsAllSelected = val
      if (val) {
        let accountUuids = []
        if (!this.filterStringAccountUuids) {
          this.allFilterData.filterInfo.userFilters.forEach(uf => accountUuids.push(uf.username))
        } else {
          this.accounts.forEach(acc => accountUuids.push(acc.username))
        }
        this.selectedAccountUuids = accountUuids
      } else {
        this.selectedAccountUuids = []
      }
    },
    getAccountsTextFilter() {
      let userFilters = this.allFilterData.filterInfo.userFilters
      let newAccounts = []
      userFilters.forEach(uf => {
        if (uf.nickname.indexOf(this.filterStringAccountUuids) !== -1) {
          newAccounts.push({ username: uf.username, nickname: uf.nickname, iconUrl: uf.iconUrl })
        }
      })
      return newAccounts
    },

    //--------------------
    // FieldQuery
    //--------------------
    getFieldQuery() {
      // 何も選択されていない
      if (this.selectedFieldGeoInfoKeys.length === 0) {
        return null
      }
      // 全て選択されている
      if (this.selectedFieldGeoInfoKeys.length === this.fields.length && this.fieldsFilterFlg === false) {
        return null
      }
      if (!this.outOfFieldHiddenFlg) {
        this.selectedFieldGeoInfoKeys.unshift('OUT_OF_FIELD')
      }
      let fieldQuery = { type: 'Field', geoInfoKeys: [] }
      if (UserInfo.isFSMigrated()) {
        fieldQuery = { type: 'Field', fieldItemIds: [] }
      }
      const allFields = this.$store.getters.fields
      // FIXME 既存のFilterをどうするか相談する
      for (let i = 0; i < this.selectedFieldGeoInfoKeys.length; i++) {
        if (UserInfo.isFSMigrated()) {
          if (this.selectedFieldGeoInfoKeys[i] === 'OUT_OF_FIELD') {
            fieldQuery.fieldItemIds.push('OUT_OF_FIELD')
          } else {
            const field = allFields.find(f => f.geoInfoKey === this.selectedFieldGeoInfoKeys[i])
            if (field) {
              fieldQuery.fieldItemIds.push(field.id)
            }
          }
        } else {
          fieldQuery.geoInfoKeys.push(this.selectedFieldGeoInfoKeys[i])
        }
      }
      return fieldQuery
    },
    toggleSelectedFieldGeoInfoKeys(val) {
      this.fieldsAllSelected = val
      if (val) {
        let fields = []
        if (!this.filterStringFieldGeoInfoKeys) {
          this.allFilterData.filterInfo.userFilters.forEach(uf => {
            uf.fields.forEach(field => fields.push(field))
          })
        } else {
          this.userFiltersForSelectFields.forEach(uf => {
            uf.fields.forEach(field => fields.push(field))
          })
        }
        this.selectedFields = fields
      } else {
        this.selectedFields = []
      }
    },
    getFieldsTextFilter() {
      const userFilters = this.allFilterData.filterInfo.userFilters
      let newUserFilters = []
      userFilters.forEach(uf => {
        let newFields = []
        uf.fields.forEach(field => {
          if (field.name) {
            if (field.name.indexOf(this.filterStringFieldGeoInfoKeys) !== -1) {
              newFields.push(field)
            }
          }
        })
        let userFilter = Object.create(uf)
        userFilter.fields = newFields
        newUserFilters.push(userFilter)
      })
      return newUserFilters
    },

    //--------------------
    // CropQuery
    //--------------------
    // getCropQuery() {
    //   // 何も選択されていない
    //   if (this.selectedCropIds.length === 0) {
    //     return null
    //   }
    //   // 全て選択されている
    //   if (this.selectedCropIds.length === Product.getUniqueCrops().length && this.cropsFilterFlg === false) {
    //     return null
    //   }
    //   let cropQuery = { type: 'Crop', ids: [] }
    //   for (let i = 0; i < this.selectedCropIds.length; i++) {
    //     cropQuery.ids.push(this.selectedCropIds[i])
    //   }
    //   return cropQuery
    // },
    // toggleSelectedCropIds(val) {
    //   this.cropsAllSelected = val
    //   if (val) {
    //     let crops = []
    //     if (!this.filterStringCropIds) {
    //       this.allFilterData.filterInfo.userFilters.forEach(uf => {
    //         uf.crops.forEach(crop => crops.push(crop))
    //       })
    //     } else {
    //       this.userFiltersForSelectCrops.forEach(uf => {
    //         uf.crops.forEach(crop => crops.push(crop))
    //       })
    //     }
    //     this.selectedCrops = crops
    //   } else {
    //     this.selectedCrops = []
    //   }
    // },
    // getCropsIdsTextFilter() {
    //   const userFilters = this.allFilterData.filterInfo.userFilters
    //   let newUserFilters = []
    //   const language = i18n.getUserLang()
    //
    //   userFilters.forEach(uf => {
    //     let newCrops = []
    //     uf.crops.forEach(crop => {
    //       const cropName = crop.localizedNames[language]
    //       if (!!cropName) {
    //         if (cropName.indexOf(this.filterStringCropIds) !== -1) {
    //           newCrops.push(crop)
    //         }
    //       }
    //     })
    //     let userFilter = Object.create(uf)
    //     userFilter.crops = newCrops
    //     newUserFilters.push(userFilter)
    //   })
    //   return newUserFilters
    // },

    //--------------------
    // OperationTypeQuery
    //--------------------
    getOperationTypeQuery() {
      // 何も選択されていない
      if (this.selectedOperationTypes.length === 0) {
        return null
      }
      // 全て選択されている
      if (
        this.selectedOperationTypes.length === this.availableOperationTypes.length &&
        this.operationTypesFilterFlg === false
      ) {
        return null
      }
      let operationQuery = { type: 'OperationType', values: [] }
      for (let i = 0; i < this.selectedOperationTypes.length; i++) {
        operationQuery.values.push(this.selectedOperationTypes[i])
      }
      return operationQuery
    },
    toggleSelectedOperationTypes(val) {
      this.operationTypesAllSelected = val
      if (val) {
        if (!this.filterStringOperationTypes) {
          this.selectedOperationTypes = this.listOperationTypes()
        } else {
          let operationTypes = []
          this.getOperationTypesTextFilter().forEach(ot => operationTypes.push(ot.value))
          this.selectedOperationTypes = operationTypes
        }
      } else {
        this.selectedOperationTypes = []
      }
    },
    listOperationTypes() {
      let array = []
      const availableOperationTypes = this.$store.getters.availableOperationTypes
      for (let i = 0; i < availableOperationTypes.length; i++) {
        array.push(availableOperationTypes[i].value)
      }
      return array
    },
    getOperationTypesTextFilter() {
      const availableOperationTypesItem = this.$store.getters.availableOperationTypes
      let availableOperationTypesFilterData = []

      for (let i in availableOperationTypesItem) {
        let operationType = availableOperationTypesItem[i]
        let types = Operation.getLocalizedName(operationType.value)
        if (types.indexOf(this.filterStringOperationTypes) !== -1) {
          availableOperationTypesFilterData.push(operationType)
        }
      }
      this.operationTypesFilterFlg = true
      return availableOperationTypesFilterData
    },

    //--------------------
    // AreaQuery（Area <> 0）
    //--------------------
    getAreaNotEqualsZeroQuery() {
      return { type: 'Area', operator: 'NotEquals', value: 0 }
    },

    //--------------------
    // DistanceQuery (Distance >= 10)
    //--------------------
    getDistanceMoreThanEquals10Query() {
      return { type: 'Distance', operator: 'MoreThanEquals', value: 10 }
    },

    convertNewTaskFilter(taskFilter) {
      let newTaskFilter = {
        username: taskFilter.userName,
        defaultFlg: taskFilter.defaultFlg,
        uuid: taskFilter.uuid,
        filterName: taskFilter.filterName,
      }
      let filterInfo = {
        operationTypes: taskFilter.operationTypes,
      }

      if (!taskFilter.areaZeroHiddenFlg) {
        filterInfo.areaZeroHiddenFlg = taskFilter.areaZeroHiddenFlg
      } else {
        filterInfo.areaZeroHiddenFlg = false
      }

      if (taskFilter.distanceUnderTenHiddenFlg) {
        filterInfo.distanceUnderTenHiddenFlg = taskFilter.distanceUnderTenHiddenFlg
      } else {
        filterInfo.distanceUnderTenHiddenFlg = false
      }
      const subscribingUserInfos = this.$store.getters.subscribingUserInfos
      let allAccountUuids = []
      allAccountUuids.push(this.myUsername)
      subscribingUserInfos.forEach(acc => {
        allAccountUuids.push(acc.uuid)
      })

      let accountUuids = []
      taskFilter.accountUuids.forEach(uuid => {
        if (allAccountUuids.includes(uuid)) {
          accountUuids.push(uuid)
        }
      })

      let userFilters = []
      accountUuids.forEach(uuid => {
        let username = uuid

        let fields = []
        const allFields = this.$store.getters.fields
        taskFilter.fieldGeoInfoKeys.forEach(geoInfoKey => {
          const field = allFields.find(f => f.geoInfoKey === geoInfoKey)
          if (field) fields.push(field)
        })

        let fieldGeoInfoKeys = []
        fields.forEach(f => {
          if (f.username === uuid) {
            fieldGeoInfoKeys.push(f.geoInfoKey)
          }
        })

        // let crops = []
        // const allCrops = Product.getUniqueCrops()
        // taskFilter.cropIds.forEach(id => {
        //   const crop = allCrops.find(c => c.id === id)
        //   if (!!crop) crops.push(crop)
        // })

        let cropIds = []
        crops.forEach(c => {
          if (c.username === uuid) {
            cropIds.push(c.id)
          }
        })

        let userFilter = {
          username: username,
          fieldGeoInfoKeys: fieldGeoInfoKeys,
          cropIds: cropIds,
        }
        userFilters.push(userFilter)
      })
      filterInfo.userFilters = userFilters

      let outOfFieldHiddenFlg = false
      taskFilter.fieldGeoInfoKeys.forEach(geoInfoKey => {
        if (geoInfoKey === 'OUT_OF_FIELD') {
          outOfFieldHiddenFlg = true
          return
        }
      })
      filterInfo.outOfFieldHiddenFlg = outOfFieldHiddenFlg
      newTaskFilter.filterInfo = filterInfo
      return newTaskFilter
    },
    setDataFromSelectFilter(selectFilter) {
      let accountUuids = []
      let fieldGeoInfoKeys = []
      let cropIds = []
      selectFilter.filterInfo.userFilters.forEach(suf => {
        const exist = this.allFilterData.filterInfo.userFilters.some(auf => auf.username === suf.username)
        if (exist) {
          accountUuids.push(suf.username)
          suf.fieldGeoInfoKeys.forEach(fgik => fieldGeoInfoKeys.push(fgik))
          suf.cropIds.forEach(cid => cropIds.push(cid))
        }
      })
      this.selectedAccountUuids = accountUuids
      this.selectedFieldGeoInfoKeys = fieldGeoInfoKeys
      this.selectedCropIds = cropIds
      this.selectedOperationTypes = selectFilter.filterInfo.operationTypes
      this.filterName = selectFilter.filterName
      this.areaZeroHiddenFlg = selectFilter.filterInfo.areaZeroHiddenFlg
      this.distanceUnderTenHiddenFlg = selectFilter.filterInfo.distanceUnderTenHiddenFlg
      this.outOfFieldHiddenFlg = selectFilter.filterInfo.outOfFieldHiddenFlg
    },
  },
  computed: {
    allFilterData() {
      let allFilterData = { filterInfo: { userFilters: [], operationTypes: [] } }

      let allAccounts = []
      allAccounts.push({ uuid: this.myUsername, nickname: this.myNickname, iconUrl: this.myIconUrl })
      this.subscribingUserInfos.forEach(acc => {
        allAccounts.push({ uuid: acc.username, nickname: acc.nickname, iconUrl: acc.iconUrl })
      })
      const allFields = this.$store.getters.fields
      // const allCrops = Product.getUniqueCrops()
      const operationTypes = this.$store.getters.availableOperationTypes
      allAccounts.forEach(acc => {
        let fields = []
        allFields.forEach(f => {
          if (f.username === acc.uuid) {
            fields.push(f)
          }
        })
        // let crops = []
        // allCrops.forEach(c => {
        //   if (c.username === acc.uuid) {
        //     crops.push(c)
        //   }
        // })
        const userFilter = {
          username: acc.uuid,
          nickname: acc.nickname,
          iconUrl: acc.iconUrl,
          fields: fields,
          // crops: crops,
        }
        allFilterData.filterInfo.userFilters.push(userFilter)
      })
      allFilterData.filterInfo.operationTypes = operationTypes
      return allFilterData
    },
    fields() {
      let fields = []
      this.allFilterData.filterInfo.userFilters.forEach(uf => {
        uf.fields.forEach(field => fields.push(field))
      })
      return fields
    },
    subscribingUserInfos() {
      return this.$store.getters.subscribingUserInfos
    },
    availableOperationTypes() {
      if (!this.filterStringOperationTypes) {
        this.operationTypesFilterFlg = false
        return this.$store.getters.availableOperationTypes
      }

      return this.getOperationTypesTextFilter()
    },
    myUsername() {
      return this.$store.getters.loginUsername
    },
    myIconUrl() {
      return UserInfo.getIconUrl()
    },
    myNickname() {
      return UserInfo.getNickname()
    },
  },
}
